import { ChevronRight, Tag, Calendar } from 'lucide-react';
import { useState } from 'react';

interface OfferCard {
  id: string;
  title: string;
  description: string;
  validUntil: string;
  code: string;
  image: string;
}

export const OffersSection = () => {
  const [offers] = useState<OfferCard[]>([
    {
      id: '1',
      title: 'Ahorra hasta ₹250 en boletos',
      description: 'Válido para viajes de más de 500 km',
      validUntil: 'Válido hasta 31 Dic',
      code: 'CASH250',
      image: '🎫'
    },
    {
      id: '2',
      title: 'Descuento del 15% en rutas seleccionadas',
      description: 'Aplica para viajes entre semana',
      validUntil: 'Válido hasta 28 Feb',
      code: 'SAVE15',
      image: '💰'
    },
    {
      id: '3',
      title: 'Viaje gratis en tu cumpleaños',
      description: 'Reserva con 7 días de anticipación',
      validUntil: 'Válido todo el año',
      code: 'BIRTHDAY',
      image: '🎂'
    }
  ]);

  return (
    <section className="bg-[#F7F8FA] py-6 lg:py-12">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="font-bold text-[#111827] text-xl">Ofertas</h2>
            <p className="text-sm text-[#6B7280] mt-1 lg:hidden">
              Descuentos al reservar boletos
            </p>
            <p className="hidden lg:block text-sm text-[#6B7280] mt-1">
              Aprovecha nuestros descuentos especiales para tu próximo viaje
            </p>
          </div>
          <button className="flex items-center gap-1 text-[#FF6A2A] font-semibold text-sm hover:text-[#C2410C] transition-colors">
            Ver todo
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>

        {/* Offers Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {offers.map((offer) => (
            <div
              key={offer.id}
              className="bg-white rounded-[16px] border border-[#E5E7EB] p-5 hover:shadow-lg transition-shadow cursor-pointer group"
            >
              <div className="flex gap-4">
                {/* Icon/Image */}
                <div className="w-16 h-16 bg-[#FFF5F0] rounded-[12px] flex items-center justify-center flex-shrink-0 text-3xl">
                  {offer.image}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-[#111827] mb-1 group-hover:text-[#FF6A2A] transition-colors">
                    {offer.title}
                  </h3>
                  <p className="text-sm text-[#6B7280] mb-3">
                    {offer.description}
                  </p>

                  {/* Validity */}
                  <div className="flex items-center gap-2 text-xs text-[#6B7280] mb-3">
                    <Calendar className="w-3.5 h-3.5" />
                    <span>{offer.validUntil}</span>
                  </div>

                  {/* Coupon Code */}
                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-1.5 px-3 py-1.5 bg-[#F7F8FA] border border-[#E5E7EB] rounded-[8px]">
                      <Tag className="w-3.5 h-3.5 text-[#FF6A2A]" />
                      <span className="text-xs font-bold text-[#111827] tracking-wide">
                        {offer.code}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
